// Audio engine for MDT: spoken button/dispatch announcements + emergency 4-tone alarm.

export function speak(text, { rate = 1, pitch = 1, volume = 1 } = {}) {
  try {
    if (!("speechSynthesis" in window)) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = rate; u.pitch = pitch; u.volume = volume; u.lang = "en-US";
    window.speechSynthesis.speak(u);
  } catch { /* noop */ }
}

let _ctx;
function ctx() {
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
}

function tone(freq, start, dur, gainVal = 0.6) {
  const c = ctx();
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "square";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(gainVal, c.currentTime + start);
  gain.gain.setValueAtTime(0.0001, c.currentTime + start + dur - 0.01);
  osc.connect(gain).connect(c.destination);
  osc.start(c.currentTime + start);
  osc.stop(c.currentTime + start + dur);
}

// Loud 4-tone emergency alarm.
export function emergencyAlarm() {
  try {
    const seq = [1046, 784, 1046, 784];
    seq.forEach((f, i) => tone(f, i * 0.22, 0.2, 0.85));
  } catch { /* noop */ }
}

// Short confirmation blip for status changes.
export function blip() {
  try { tone(660, 0, 0.09, 0.35); } catch { /* noop */ }
}

// Three sharp beeps (used before a spoken unit-status announcement).
export function statusBeeps() {
  try {
    tone(880, 0, 0.09, 0.5);
    tone(880, 0.15, 0.09, 0.5);
    tone(880, 0.30, 0.09, 0.5);
  } catch { /* noop */ }
}

// Three short beeps signalling an incoming MDT message ("message received").
export function messageBeeps() {
  try {
    tone(1175, 0, 0.08, 0.5);
    tone(1175, 0.13, 0.08, 0.5);
    tone(1175, 0.26, 0.08, 0.5);
    tone(1175, 0.39, 0.08, 0.5);
  } catch { /* noop */ }
}

// 3 beeps, then the spoken status label (Available / En Route / etc.).
export function announceStatus(label) {
  statusBeeps();
  setTimeout(() => speak(label), 480);
}

// Distinct 3-tone premise-hazard warning (requires acknowledgment).
export function hazardTone() {
  try {
    tone(740, 0, 0.18, 0.8);
    tone(560, 0.2, 0.18, 0.8);
    tone(740, 0.4, 0.22, 0.85);
  } catch { /* noop */ }
}
